import { render, staticRenderFns } from "./CatchmentAreaInformation.vue?vue&type=template&id=aa2d0220&"
import script from "./CatchmentAreaInformation.vue?vue&type=script&lang=ts&"
export * from "./CatchmentAreaInformation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports